
  <div class="modal-header w-100">

    <h3 class="text-center title justify-content-center m-0 w-100">Choisissez une entreprise</h3>
  
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class=" mb-3">
      <table id="Table" class="table">
        <thead class="head-table">
          <tr>
            <th>#</th>
            <th>Nom Commercial</th>
            <th>Raison sociale</th>
            <th>Téléphone</th>
            <th>SIREN</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody class="body-table">
          <tr *ngFor="let item of list_prospect_pro; let index = index" (click)="toggleSelection(index);sendDataIndismiss(item)" class="hover-effect">
            <td>{{ index+1 }}</td>
            <td>{{ item.Nom_Commercial ? item.Nom_Commercial:"-" }}</td>
            <td>{{ item.RS }}</td>
            <td>{{ item.tel ? item.tel:"-"}}</td>
            <td>{{ item.SIREN }}</td>
            <td>
              <img src="/assets/img/Groupe2.svg" *ngIf="!isSelected(index)" (click)="sendDataIndismiss(item)">
              <img src="/assets/img/Groupe1.svg" *ngIf="isSelected(index)" >
            </td>
          </tr>
        </tbody>
      </table>
      <ng-container *ngIf="loader">
        <div class="col-12 text-center d-flex justify-content-center">
            <mat-spinner [diameter]="20"></mat-spinner>
        </div>
    </ng-container>
      <div *ngIf="list_prospect_pro?.length === 0 && !loader" class="row pt-2">
        <div class="col-12  d-flex justify-content-center">
          <img src="assets/icons/nodata.svg">
        </div>
        <div class="col-12  d-flex justify-content-center">
          <p class="noData">Pas de données disponibles</p>
       </div>
      </div>
      <div class="navbar-center mb-4 row" *ngIf="list_prospect_pro.length >0">
     
        <div class="col justify-content-center d-flex">
          <nav aria-label="Page navigation example" *ngIf="totalPages>0">
            <ul class="pagination pg-blue">
              <li (click)="first()" class="page-item" [ngClass]="{'disabled':isFirst()}">
                <a class="page-link-symbol">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li *ngIf="!isFirst()" (click)="prev()" class="page-item mx-2">
                <a class="page-link-symbol-chevron" aria-label="Previous">
                  <i class="fa fa-chevron-left "></i>
                </a>
              </li>
              <ng-container *ngFor="let item of [].constructor(3); let i = index">
                <li *ngIf="i+page-3>0" class="page-item">
                  <a (click)="changepage(i+page-3)" class="page-link mt-2 border rounded">{{i + page - 3}}</a>
                </li>
              </ng-container>
              <ng-container *ngFor="let item of [].constructor(3); let i = index">
                <li *ngIf="i+page<totalPages" class="page-item">
                  <a (click)="changepage(i+page)" class="page-link mt-2 border rounded"
                    [ngClass]="{'active-page':page==(i+page)}">
                    {{i + page}}
                  </a>
                </li>
              </ng-container>
              <li *ngIf="totalPages>1 && totalPages > 3 " class="m-2"> ... </li>
              <li class="page-item">
                <a (click)="changepage(totalPages)" class="page-link mt-2 border rounded"
                  [ngClass]="{'active-page':page==totalPages}">{{totalPages}}</a>
              </li>
              <li *ngIf="!isLast()" (click)="next()" class="page-item mx-2">
                <a class="page-link-symbol-chevron" aria-label="Next">
                  <i class="fa fa-chevron-right"></i>
                </a>
              </li>
              <li (click)="last()" class="page-item" [ngClass]="{'disabled':isLast()}">
                <a class="page-link-symbol">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
    
      </div>
    </div>
  </div>
